import React from 'react';
import PropTypes from 'prop-types';
import equal from 'fast-deep-equal';
import Flexbox from 'components/flexbox';
import LegendItem from 'components/legend-item';
import {getMaxLineIndex} from 'utils/data-util';
import {truncate} from 'common/utils/string-util';
import styles from './index.css';

export default class Legend extends React.Component {
  static propTypes = {
    height: PropTypes.number,
    series: PropTypes.array,
    setLegendRows: PropTypes.func,
    spacing: PropTypes.number,
    width: PropTypes.number,
    x: PropTypes.number,
    y: PropTypes.number,
  };

  static defaultProps = {
    height: 0,
    series: [],
    setLegendRows: () => {},
    spacing: 22,
    width: 0,
    x: 0,
    y: 0,
  };

  constructor() {
    super();
    this.onLayout = this.onLayout.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (equal(this.props, nextProps) && equal(this.state, nextState)) {
      return false;
    }
    return true;
  }

  render() {
    return (
      <Flexbox
        className={styles.Legend}
        onLayout={this.onLayout}
        style={{
          alignItems: 'center',
          flexDirection: 'row',
          flexWrap: 'wrap',
          height: this.props.height,
          justifyContent: 'flex-start',
          paddingLeft: Math.round(this.props.x / 4) || this.props.x,
          width: this.props.width,
        }}
        x={this.props.x}
        y={this.props.y}>
        {this.props.series.map((datum, index) => (
          <LegendItem
            key={index}
            label={truncate(datum.legendLabel)}
            mask={datum.mask}
            style={{
              ...datum.style,
              marginBottom: Math.round(this.props.height / 2),
              marginRight: Math.round(this.props.x / 2) || this.props.spacing,
            }}
            type={datum.type}
          />
        ))}
      </Flexbox>
    );
  }

  onLayout(layout) {
    this.props.setLegendRows(getMaxLineIndex(layout.children));
  }
}
